import { LitElement, html } from "lit"

import { i18n } from "../../../internationalize/i18n.service"
import type { AuthService } from "../../services/auth.service"

import styleCSS from './signout.component.scss?raw'

export class SignoutButtonComponent extends LitElement {
  constructor(private authService:AuthService = window.tbwServices.authService) {super(); }
  logout() {
    this.authService.logout()
    window.location.replace('/login')
  }

  render()  {
    return html`
      <style>
        ${styleCSS}
      </style>
      <button class="logout-btn" @click="${() => this.logout()}">${i18n.t("logout")}</button>
    `
  }
}